import { create } from 'zustand';

export interface LogEntry {
    id: string;
    timestamp: number;
    level: 'info' | 'warn' | 'error' | 'success';
    tag: string;
    message: string;
    detail?: string;
}

interface LogState {
    logs: LogEntry[];
    maxLogs: number;
    addLog: (level: LogEntry['level'], tag: string, message: string, detail?: string) => void;
    clearLogs: () => void;
}

export const useLogStore = create<LogState>((set, get) => ({
    logs: [],
    maxLogs: 500,

    addLog: (level, tag, message, detail) => {
        const entry: LogEntry = {
            id: `${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
            timestamp: Date.now(),
            level,
            tag,
            message,
            detail,
        };
        set((state) => {
            const next = [entry, ...state.logs];
            if (next.length > state.maxLogs) next.length = state.maxLogs;
            return { logs: next };
        });
    },

    clearLogs: () => set({ logs: [] }),
}));

// 便捷方法
export const logInfo = (tag: string, message: string, detail?: string) => useLogStore.getState().addLog('info', tag, message, detail);
export const logWarn = (tag: string, message: string, detail?: string) => useLogStore.getState().addLog('warn', tag, message, detail);
export const logError = (tag: string, message: string, detail?: string) => useLogStore.getState().addLog('error', tag, message, detail);
export const logSuccess = (tag: string, message: string, detail?: string) => useLogStore.getState().addLog('success', tag, message, detail);
